var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5926 14.9892L16.445 13.6776C15.9098 13.4544 15.2918 13.6092 14.9234 14.058L13.907 15.2988C13.727 15.5184 13.4126 15.5904 13.1618 15.4572C11.1962 14.418 9.58216 12.804 8.54416 10.8396C8.41096 10.5876 8.48296 10.2732 8.70256 10.0932L9.94216 9.07919C10.391 8.71319 10.5458 8.09519 10.3226 7.55999L9.01096 4.41119V4.40759C8.75776 3.79799 8.09176 3.47279 7.45576 3.64679L4.56856 4.43399C4.01296 4.58519 3.60136 5.08199 3.60016 5.65799C3.57736 13.8096 10.1906 20.424 18.3422 20.4C18.917 20.3988 19.4138 19.9872 19.565 19.4316L20.3522 16.5444C20.5274 15.9096 20.201 15.2436 19.5926 14.9892Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c4cf09f096449d1f1d50e67c003d8403.svg";
export { ForwardRef as ReactComponent };